import { Form } from 'components/Form/Form';
import {
  FormContextValue,
  FormSubmitFunction,
} from 'components/Form/FormContext';
import { SubmitButton } from 'components/Form/SubmitButton/SubmitButton';
import { TextAreaField } from 'components/Form/TextAreaField';
import { Modal } from 'modals/Modal';
import {
  FeedbackModalActions,
  FeedbackModalIcon,
} from 'modules/cms/pages/Page/CmsHelpPageFeedback/FeedbackModal.styled';
import { getStaticImageSrc } from 'utils/getImageSrc';

type FeedbackModalProps = {
  isPositive: boolean;
  onSubmit: (comment: string) => Promise<void>;
  onClose: (hasSubmittedFeedback: boolean) => void;
};

type FeedbackFormValues = {
  comment: string;
};

export function FeedbackModal({
  isPositive,
  onSubmit,
  onClose,
}: FeedbackModalProps) {
  const handleSubmit: FormSubmitFunction<FeedbackFormValues> = async ({
    values,
  }) => {
    await onSubmit(values.comment);
    onClose(true);
  };

  return (
    <Modal
      title={
        isPositive
          ? getText('What specifically did you like about the article?')
          : getText('How could we have done better?')
      }
      onClose={() => onClose(false)}
      data-qa-id="help-article-feedback-modal"
      image={
        <FeedbackModalIcon
          src={getStaticImageSrc('feedback-modal-icon-lightbulb.svg')}
          alt="Help article feedback modal"
        />
      }
    >
      <Form<FeedbackFormValues, FormContextValue<FeedbackFormValues>>
        analyticsTitle="Help article feedback modal"
        usageContext="modal"
        data-qa-id="help-article-feedback-form"
        onSubmit={handleSubmit}
        render={() => (
          <>
            <TextAreaField
              name="comment"
              rows={6}
              placeholder={getText('Enter text here…')}
            />
            <FeedbackModalActions>
              <SubmitButton>Submit</SubmitButton>
            </FeedbackModalActions>
          </>
        )}
      />
    </Modal>
  );
}
